import { shouldPolyfill } from '@formatjs/intl-datetimeformat/should-polyfill';

export const intlPolyfill = async (locale: string) => {
  const unsupportedLocale = shouldPolyfill(locale);

  /* Так как webpack раздувает бандл при нестатической строке в динамическом импорте,
   а не поддерживаемая локаль на данный момент 'kk', добавляем только 'kk' */
  if (!unsupportedLocale || unsupportedLocale !== 'kk') {
    return;
  }

  // Load the polyfill 1st BEFORE loading data
  await import('@formatjs/intl-datetimeformat/polyfill-force');

  // Parallelize CLDR data loading
  const dataPolyfills = [
    import('@formatjs/intl-datetimeformat/add-all-tz'),
    import(`@formatjs/intl-datetimeformat/locale-data/kk`),
  ];
  await Promise.all(dataPolyfills);
};
